module.exports = __webpack_public_path__ + "img/soth-trivia-screen-table.e42307e0.png";